<template>
  <b-modal
    title="NOVO GRUPO"
    id="new_group"
    no-close-on-backdrop
    hide-footer
    @show="evOnShow"
    @shown="evOnShown"
  >
    <b-overlay :show="loading" opacity="0.99">
      <form @submit.prevent="evOnSubmit">
        <div class="row">
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <LabelRequiredField label="Nome" />
            <input
              type="text"
              ref="autofocus"
              class="form-control"
              v-model="group_name"
            />
          </div>
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <label>Descrição</label>
            <input
              type="text"
              class="form-control"
              v-model="group_description"
            />
          </div>
          <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <WarningRequiredFields />
            <ErrorsMessages :errors="errors" />
          </div>
          <div
            class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-right"
          >
            <v-btn type="submit" class="btn-save">
              <i class="fas fa-save mr-2 text-twenty"></i>
              SALVAR
            </v-btn>
          </div>
        </div>
      </form>
    </b-overlay>
  </b-modal>
</template>

<script>
import WarningRequiredFields from "../Components/WarningRequiredFields";
import LabelRequiredField from "../Components/LabelRequiredField";
import ErrorsMessages from "../Components/ErrorsMessages";
import toast from "../../lib/ToastNotification";
import api from "../../services/api";

export default {
  name: "NewGroup",
  components: {
    WarningRequiredFields,
    LabelRequiredField,
    ErrorsMessages,
  },
  data() {
    return {
      errors: [],
      loading: false,

      group_name: "",
      group_description: "",
    };
  },
  methods: {
    async evOnShow() {
      this.group_name = "";
      this.group_description = "";
    },

    async evOnShown() {
      this.$refs.autofocus.focus();
    },

    async evOnSubmit() {
      try {
        this.loading = true;

        const params = {
          name: this.group_name,
          description: this.group_description,
        };
        const response = await api.post("/rest-home/group", params);
        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.$bvModal.hide("new_group");
          toast(message, "success");
          this.$emit("created");
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style></style>
